import type { ScheduleItem } from '../../types/domain.js'
import { GLUED_TOLERANCE_MS, type InfoserviceInsertPlan } from './infoserviceResize.js'

export type AgendaEdgeAction = 'ADD' | 'INSERT' | 'NONE'

/**
 * Choisit le geste promis par un bouton de bord.
 *
 * « Insérer » est réservé au cas où un infoservice peut réellement céder du
 * temps. Une intersection occupée sans recalage disponible ne doit proposer
 * aucun ajout : ce geste poserait le nouvel élément par-dessus son voisin.
 */
export function agendaEdgeAction(
  hasGap: boolean,
  insertPlans: InfoserviceInsertPlan[] | null,
): AgendaEdgeAction {
  if (hasGap) return 'ADD'
  if (insertPlans === null) return 'NONE'
  return insertPlans.length > 0 ? 'INSERT' : 'NONE'
}

/**
 * Dit si un bord de bloc ouvre sur un trou plutôt que sur une intersection.
 *
 * Le seuil est celui du collage strict : une réserve laissée volontairement
 * entre deux programmes — quelques secondes pour y glisser un jingle — est un
 * trou, et doit donc mener au geste « Ajouter », qui remplit la place existante
 * au lieu de décaler la séquence entière comme le ferait « Insérer ».
 */
export function agendaEdgeHasGap(
  items: ScheduleItem[],
  excludeId: string,
  boundaryMs: number,
  edge: 'startTime' | 'endTime',
): boolean {
  return !items.some(other => (
    other.id !== excludeId && other.status !== 'SKIPPED' &&
    Math.abs(new Date(other[edge]).getTime() - boundaryMs) <= GLUED_TOLERANCE_MS
  ))
}
